import * as React from "react";
import LessonBadge from "./LessonBadge";
import reloadIcon from "../../../../assets/images/icon-reload.svg"
import lessonTitleBadge from "../../../../assets/images/lessonBadge.svg"

const LessonNavigation = ({ round, maxRound, onIncrement, onDecrement, reload, level, chapter, stageName, lessonTitle }) =>{

    return (
        <div className="flex flex-row justify-between">
            <div className="flex flex-col gap-3 justify-center">
                <div className="flex flex-wrap gap-2.5 items-center max-md:max-w-full">
                    <LessonBadge level={level} unit={chapter}/>
                    <div
                        className="flex gap-3 flex-1 text-base items-center font-black text-zinc-600 text-left max-md:max-w-full ">
                        {stageName}

                    </div>
                </div>
                {lessonTitle && (
                    <div className="flex flex-wrap gap-2.5 items-center max-md:max-w-full">
                        <img
                            src={lessonTitleBadge}
                            alt="badge"
                            className="flex"
                        />
                        <div className="flex text-[#91959d] text-xs font-semibold font-['Inter']">
                            {lessonTitle}
                        </div>
                    </div>
                )}
            </div>

            <button
                className="flex justify-center items-center self-stretch px-1 py-0.5 my-auto rotate-[-8.742277657347563e-8rad] min-w-8"
                onClick={reload}>
                <img
                    loading="lazy"
                    src={reloadIcon}
                    alt="arrow"
                    className="object-contain self-stretch my-auto w-[50px]"
                />
            </button>
        </div>
)
    ;
}

export default LessonNavigation;